import { SimplifiedContractStatus } from './types'
import { VolumeEntry } from 'pages/app/consumption/your-consumption/components/consumption-section/types.ts'
import { TagProps } from '@boltenergy-be/design-system'
import { CounterType, Direction, Situation, TimeframeCode } from '@boltenergy-be/shared'

// REQUEST & RESPONSE TYPES

export type CreateMeterReadingsRequest = {
  date: string // ISO string
  contractNumber: string
  ean: string
  indexes?: Index[]
}

export type GetServiceContractVolumesResponseData = {
  volumes: VolumeEntry[]
}

// GENERAL CONTRACT TYPES

export type ContractDataWithIndexes = {
  contractNumber: string
  ean: string
  indexes?: Index[]
}

export type Index = {
  meterNumber: string
  registerName: string
  timeframeCode: TimeframeCode
  value: number
  direction: Direction
}

export type MeterReading = {
  singleRate?: number
  exclNight?: number
  doubleRate?: {
    day?: number
    night?: number
  }
}

export type MeterReadings = {
  electricity?: MeterReadingEntry | null
  gas?: MeterReadingEntry | null
}

export type MeterReadingEntry = {
  ean: string
  date: string // ISO date string
  source: MeterReadingSource
  consumption: MeterReading
  injection?: MeterReading
}

export type MeterReadingsElectricityPayload = {
  ean: string
  consumption: MeterReading
  injection?: MeterReading
}

export type MeterReadingsGasPayload = {
  ean: string
  consumption: MeterReading
}

export type MeterReadingsPayload = {
  date: string // ISO
  electricity?: MeterReadingsElectricityPayload
  gas?: MeterReadingsGasPayload
}

export type FormatContractStatus = {
  key:
    | SimplifiedContractStatus.INACTIVE
    | SimplifiedContractStatus.IN_PROGRESS
    | SimplifiedContractStatus.CANCELLED
    | 'activeSince'
    | 'startingOn'
    | 'terminatedSince'
    | 'terminatingOn'
  type: TagProps['type']
  date?: string // ISO
}

export type CheckHasMeterAndReadingInputs = {
  situation: Situation
  counterType: CounterType
  contractStartDate: string | null
}

// ENUMS

export enum Granularity {
  MONTH = 'MONTH',
  DAY = 'DAY',
  HOUR = 'HOUR',
  QUARTER_HOUR = 'QUARTER_HOUR'
}

export enum MeterIndexType {
  TOTAL = 'total',
  DAY = 'day',
  NIGHT = 'night',
  EXCL_NIGHT = 'exclNight'
}

export enum MeterReadingSource {
  CLIENT_PROVIDED = 'CLIENT_PROVIDED',
  EOD_DGO = 'EOD_DGO'
}
